import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { delay: { type: Number, default: 3000 } }

    connect() {
        this.setupHeroObserver()
        this.setupFooterObserver()
        this.setupScrollListener()
    }

    disconnect() {
        if (this.heroObserver) {
            this.heroObserver.disconnect()
        }
        if (this.footerObserver) {
            this.footerObserver.disconnect()
        }
        if (this.scrollListener) {
            window.removeEventListener('scroll', this.scrollListener)
        }
    }

    setupHeroObserver() {
        const heroSection = document.querySelector('section') // First section is the hero
        if (!heroSection) return

        this.heroObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    // Hero is out of view, show CTA
                    this.show()
                } else {
                    // Hero is in view, hide CTA
                    this.hide()
                }
            })
        }, {
            threshold: 0.1
        })

        this.heroObserver.observe(heroSection)
    }

    setupFooterObserver() {
        const footer = document.querySelector('footer')
        if (!footer) return

        this.footerObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.hideForFooter()
                } else {
                    this.showForFooter()
                }
            })
        }, {
            rootMargin: '100px 0px 0px 0px' // Show CTA 100px before footer appears
        })

        this.footerObserver.observe(footer)
    }

    setupScrollListener() {
        let ticking = false
        this.scrollListener = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    this.checkFooterOverlap()
                    ticking = false
                })
                ticking = true
            }
        }
        window.addEventListener('scroll', this.scrollListener, { passive: true })
    }

    checkFooterOverlap() {
        const footer = document.querySelector('footer')
        if (!footer) return

        const footerRect = footer.getBoundingClientRect()
        const ctaRect = this.element.getBoundingClientRect()
        const windowHeight = window.innerHeight

        // Check if CTA would overlap with footer
        const footerTop = footerRect.top
        const ctaBottom = ctaRect.bottom

        if (footerTop < windowHeight && footerTop < ctaBottom + 20) { // 20px buffer
            this.hideForFooter()
        } else {
            this.showForFooter()
        }
    }

    show() {
        this.element.classList.remove("opacity-0", "scale-95", "translate-y-2")
        this.element.classList.add("opacity-100", "scale-100", "translate-y-0")
        this.element.style.display = "block"
        this.isVisible = true
    }

    hide() {
        this.element.classList.add("opacity-0", "scale-95", "translate-y-2")
        this.element.classList.remove("opacity-100", "scale-100", "translate-y-0")

        setTimeout(() => {
            this.element.style.display = "none"
        }, 300)
        this.isVisible = false
    }

    hideForFooter() {
        if (this.isVisible) {
            this.element.style.opacity = "0"
            this.element.style.transform = "scale(0.95) translateY(8px)"
            this.hiddenForFooter = true
        }
    }

    showForFooter() {
        if (this.hiddenForFooter && this.isVisible) {
            this.element.style.opacity = "1"
            this.element.style.transform = "scale(1) translateY(0)"
            this.hiddenForFooter = false
        }
    }
} 